import smoothscroll from './utilities/smoothscroll.js';
import scrollHeader from './utilities/scrollHeader.js';
import validate from './vendors/jquery.validate.min.js';

import qa from './page/qa.js';


import 'jquery.easing';
import 'jquery.easing';
// import '@fancyapps/fancybox';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

$(() => {
	smoothscroll();
  scrollHeader();
  qa();

  $.extend($.validator.messages, {
  	// required: "このフィールドは必須です。",
  	required: "{1}を入力してください。",
  	number: "ハイフン無し、半角数字のみで入力してください。",
  	email: "半角英数字でメールアドレスを入力してください。",
  });

  $("#cf").validate({
  	rules: {
  		name: {
  			required: [true,"名前"]
  		},
  		tel: {
  			number: true
  		},
  		email: {
  			required: [true,"メールアドレス"],
  			email: true
  		},
  		content: {
  			required: [true,"内容"]
  		}
  	}
  });

});



// WEBPACK FOOTER //
// ./src/assets/js/main.js